var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5195_13238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37 7.74985L5.34 9.71985C5.41369 9.78851 5.47279 9.87131 5.51378 9.96331C5.55477 10.0553 5.57681 10.1546 5.57859 10.2553C5.58037 10.356 5.56184 10.4561 5.52412 10.5494C5.4864 10.6428 5.43026 10.7277 5.35904 10.7989C5.28782 10.8701 5.20299 10.9262 5.1096 10.964C5.01621 11.0017 4.91618 11.0202 4.81548 11.0184C4.71477 11.0167 4.61546 10.9946 4.52346 10.9536C4.43146 10.9126 4.34866 10.8535 4.28 10.7798L1.03 7.52985L0.5 6.99985L1.03 6.46985L4.28 3.21985C4.42217 3.08737 4.61022 3.01524 4.80452 3.01867C4.99882 3.0221 5.18421 3.10081 5.32162 3.23822C5.45903 3.37564 5.53775 3.56102 5.54117 3.75532C5.5446 3.94963 5.47248 4.13767 5.34 4.27985L3.37 6.24985H13.25C14.112 6.24985 14.9386 6.59226 15.5481 7.20175C16.1576 7.81124 16.5 8.63789 16.5 9.49985C16.5 10.3618 16.1576 11.1884 15.5481 11.7979C14.9386 12.4074 14.112 12.7498 13.25 12.7498H11.25C11.0511 12.7498 10.8603 12.6708 10.7197 12.5302C10.579 12.3895 10.5 12.1988 10.5 11.9998C10.5 11.8009 10.579 11.6102 10.7197 11.4695C10.8603 11.3289 11.0511 11.2498 11.25 11.2498H13.25C13.7141 11.2498 14.1592 11.0655 14.4874 10.7373C14.8156 10.4091 15 9.96398 15 9.49985C15 9.03572 14.8156 8.5906 14.4874 8.26241C14.1592 7.93422 13.7141 7.74985 13.25 7.74985H3.37Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5195_13238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreIcon);
export default __webpack_public_path__ + "static/media/restoreIcon.957e8e8aa42a0d404660fb160ed0ea72.svg";
export { ForwardRef as ReactComponent };